import { selectCategory } from "@/store/slices/category";
import styles from "./banner.module.scss";
import Image from "next/image";
import React from "react";
import { useSelector } from "react-redux";

const BannerMobile = () => {
  const categoryState = useSelector(selectCategory);

  return (
    <>
    <div className="container-fluid">
      {!!categoryState.data?.mob_banner_image && (
        <section className={styles.banner_mobile}>
          {categoryState.data.mob_banner_link ? (
            <a
              href={categoryState.data.mob_banner_link}
              target={categoryState.data.mob_banner_link_target || "_self"}
            >
              <Image
                src={categoryState.data.mob_banner_image}
                alt={categoryState.data.title}
                layout="responsive"
                width={768}
                height={400}
                objectFit="cover"
                unoptimized
                priority
              />
            </a>
          ) : (
            <Image
              src={categoryState.data.mob_banner_image}
              alt={categoryState.data.title}
              layout="responsive"
              width={768}
              height={400}
              objectFit="cover"
              unoptimized
              priority
            />
          )}
        </section>
      )}
      {!!categoryState.data?.firework_snippet && (
        <div
          className="my-3"
          dangerouslySetInnerHTML={{
            __html: categoryState.data.firework_snippet,
          }}
        ></div>
      )}
      </div>
    </>
  );
};

export default BannerMobile;
